import {EntityApiService, ApiClientService} from '@dofleini/security';
import {OperatorFilter} from '@dofleini/query-builder';

class AuditsApiService extends EntityApiService {

  constructor(path) {
    super();
    this.summaryParams = {};
    this.path = path;
  }

  getSummaryParams(params){
    let fromBack = this.summaryParams?.filters || [];
    if(fromBack?.filters?.length)
      fromBack = this.summaryParams?.filters?.filters;
    const fromUI = params?.filters?.filters?.length ? params?.filters?.filters: [params?.filters] ;

    const filters = new OperatorFilter({type: 'AND', filters: fromUI?.concat(fromBack)?.map(x => (x))}).toQuery();
    return {...this.summaryParams, ...params, filters};
  }

  getPlainParams() {
    return this.summaryParams;
  }

  setSummaryParams(params){
    this.summaryParams = params;
  }

  summarySearch = (params) => {
    return ApiClientService.post(this.getPath('/search-summary-from-client'), this.getSummaryParams(params));
  }

}

export default new AuditsApiService('/ms-core/api/audits');
